import styled from "styled-components";

export const DeckModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
  max-width: calc(100vw - var(--space-6));
  width: 500px;
  outline: none;
  animation: pop-in var(--dur-slow) var(--ease-bounce) both;

  > .MuiCard-root {
    border-color: var(--ink);
    border-radius: var(--radius-xl);
    box-shadow: 0 6px 0 var(--ink), var(--shadow-float);
  }
`;

export const DeckModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding-bottom: var(--space-4);

  h1,
  h4 {
    margin: 0;
    flex: 1;
  }

  button {
    min-width: unset;
  }
`;

export const DeckModalForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  width: 100%;
`;
